module.exports = __webpack_public_path__ + "img/68ba4f4bf02f4c8686555aac108e5294.db177e03.png";